export default "__VITE_ASSET__abba1ae5__"